var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"playerDiv",staticClass:"player",style:({height: `${_vm.playerHeight}px`})},[_c('div',{staticClass:"player-wrapper"},[_c('video',{ref:"video",staticClass:"video-js video-js-player vjs-theme-fantasy",attrs:{"controls":_vm.controls,"data-setup":_vm.settings}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }